import * as React from 'react';
import { Row, Col } from 'antd';
import ApplicableProductSelectionEditor from 'app/pages/DiscountEditor/components/ApplicableProductsSelectionEditor';
import DiscountDatesEditor from 'app/pages/DiscountEditor/components/DiscountDatesEditor';
import SchoolSelectionEditor from 'app/pages/DiscountEditor/components/SchoolSelectionEditor';
import BasicInfoEditor from 'app/pages/DiscountEditor/components/BasicInfoEditor';
import DiscountActionTable from 'app/pages/DiscountEditor/components/DiscountActionTable';
import AgentsSelectionEditor from 'app/pages/DiscountEditor/components/AgentsSelectionEditor';
import CountrySelectionEditor from 'app/pages/DiscountEditor/components/CountrySelectionEditor';
import AdditionalCriteriaEditor from 'app/pages/DiscountEditor/components/AdditionalCriteriaEditor';
import DivisionSelectionEditor from 'app/pages/DiscountEditor/components/DivisionSelectionEditor';

const DiscountWidgets = (props: {}) => (
    <Row gutter={[16, 16]}>
        <Col xs={24} lg={14}>
            <BasicInfoEditor />
            <ApplicableProductSelectionEditor />
            <DiscountActionTable />
            <AdditionalCriteriaEditor />
        </Col>
        <Col xs={24} lg={10}>
            <DivisionSelectionEditor />
            <SchoolSelectionEditor />
            <DiscountDatesEditor />
            <CountrySelectionEditor />
            <AgentsSelectionEditor />
        </Col>
    </Row>
);

export default DiscountWidgets;